import "./style.css";

export const Divider = ({ ...props }) => {
  return <div className="pure-divider" {...props}></div>;
};
